import * as React from 'react';
import * as styles from './MortgageBanner.css';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { ILinkButtonProps } from '@cian/ui-kit/button/types';
import mortgageLogo from './assets/logo.svg';
import { MORTGAGE_BANNER_DISPLAY_NAME, trackMortgageBannerClick, trackMortgageBannerShow } from './tracking';

const MORTGAGE_LINK = `https://www.cian.ru/ipoteka-main/?${new URLSearchParams({
  cian_source: 'cian',
  cian_medium: 'trap',
  cian_campaign: 'mortgage_banner',
  cian_content: 'listing_suburban_build_house',
}).toString()}`;

export const MortgageBanner: React.FC = () => {
  const deviceType = useDeviceType();
  const rootRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const root = rootRef.current;
    if (!root) {
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          trackMortgageBannerShow();
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(root);

    return () => observer.disconnect();
  }, []);

  const buttonProps = React.useMemo<ILinkButtonProps>(() => {
    switch (deviceType) {
      case 'desktop':
        return { size: 'L', target: '_blank' };
      case 'tablet':
        return { size: 'L' };
      case 'phone':
        return { size: 'M', fullWidth: true };
    }
  }, [deviceType]);

  return (
    <div ref={rootRef} className={styles['mortgage-banner']}>
      <img className={styles['logo']} src={mortgageLogo} />
      <div className={styles['inner']}>
        <div className={styles['title']}>{MORTGAGE_BANNER_DISPLAY_NAME}</div>
        <div className={styles['description']}>Выгодные программы господдержки</div>
        <LinkButton {...buttonProps} theme="fill_primary" href={MORTGAGE_LINK} onClick={trackMortgageBannerClick}>
          Узнать свои ставки
        </LinkButton>
      </div>
    </div>
  );
};
